<app-alert></app-alert>
<router-outlet></router-outlet>
@defer (on idle) {
    <app-event-products-calculator></app-event-products-calculator>
}
